/* MTL — Dynamic selected color name + required-state UX 2026-05-12 v2
 * (2026-08-11: clearDefaultActive retired — gold is preselected)
 *
 * Inserts ": GOLD" / ": ROSE GOLD" / ": STAINLESS STEEL" inline next to the
 * "CHOOSE YOUR FINISH" label, with text color matching the swatch tone.
 *
 * CHANGED 2026-08-11: clearDefaultActive() used to strip the server-rendered
 * default-active (gold) swatch on load — at init, +600ms and +1800ms — which is
 * what left the finish picker showing nothing selected. It already made an
 * exception for [data-self-gated="true"] PDPs, where gold stays selected and the
 * correct variant id stays bound; that exception is now the rule for every PDP.
 * The function is kept as a documented no-op so the call sites and the file's
 * shape stay recognisable for rollback.
 *
 * Everything else — label text, swatch tone, click binding, MutationObserver —
 * is unchanged, so the label now reads ": GOLD" on arrival instead of blank.
 *
 * Reversible: restore from the dated snapshot in Ops/snapshots/.
 */
(function() {
  'use strict';
  /* 2026-10-29 (Kayla): also run on Canada English /en-ca/products/ URLs, same as the US. fr-ca unchanged (French on hold). SAFE TO REVERT: restore the startsWith line. */
  if (!/^\/(en-ca\/)?products\//.test(window.location.pathname)) return;

  function ensureSelectedSpan() {
    var label = document.querySelector('.mtl-p .step.step-finish .step-label');
    if (!label) return null;
    var span = label.querySelector('.mtl-selected-color');
    if (!span) {
      span = document.createElement('span');
      span.className = 'mtl-selected-color';
      label.appendChild(span);
    }
    return span;
  }

  /* RETIRED 2026-08-11 — no longer strips the default gold selection. */
  function clearDefaultActive() { /* intentionally empty */ }

  /* Keep the server's default selection visible if nothing is active yet.
   * NEVER invents a choice: it mirrors the variant the server already bound in
   * input[name="id"]. Only falls back to the "gold" key on static-swatch
   * products (no data-variant-id), where finish is a line-item property and
   * every swatch shares one variant. Two-tone products (e.g. the sliding-bar
   * "Gold Outside / Stainless Outside" paw bars) therefore keep whatever the
   * server chose and are never flipped to a different variant. */
  function ensureDefaultActive() {
    var form = document.querySelector('.mtl-p');
    if (!form) return;
    if (form.querySelector('[data-mtl-swatch].active')) return;

    var idInput = form.querySelector('input[name="id"]');
    var bound = idInput && form.querySelector(
      '[data-mtl-swatch][data-variant-id="' + idInput.value + '"]'
    );
    if (bound) {
      bound.classList.add('active');
      bound.setAttribute('aria-pressed', 'true');
      return;
    }

    // Variant-bound swatches exist but none matches the bound variant:
    // leave well alone rather than guess.
    if (form.querySelector('[data-mtl-swatch][data-variant-id]')) return;

    var gold = form.querySelector('[data-mtl-swatch="gold"]');
    if (gold) {
      gold.classList.add('active');
      gold.setAttribute('aria-pressed', 'true');
    }
  }

  function updateLabel() {
    var active = document.querySelector('.mtl-p [data-mtl-swatch].active');
    var span = ensureSelectedSpan();
    if (!span) return;
    if (!active) {
      span.textContent = '';
      span.removeAttribute('data-color');
      return;
    }
    var name = active.querySelector('.swatch-name');
    var labelText = '';
    if (name && name.firstChild) {
      labelText = name.firstChild.textContent || '';
    }
    if (!labelText) labelText = active.getAttribute('aria-label') || active.dataset.mtlSwatch || '';
    span.textContent = ': ' + labelText.trim().toUpperCase();
    span.setAttribute('data-color', active.dataset.mtlSwatch || '');
  }

  function bindClicks() {
    document.querySelectorAll('.mtl-p [data-mtl-swatch]').forEach(function(btn) {
      if (btn.__mtlLabelBound) return;
      btn.__mtlLabelBound = true;
      btn.addEventListener('click', function() {
        try { sessionStorage.setItem('mtl-color-picked-' + window.location.pathname, 'true'); } catch (e) {}
        setTimeout(updateLabel, 30);
      });
    });
  }

  function init() {
    ensureSelectedSpan();
    clearDefaultActive();
    ensureDefaultActive();
    updateLabel();
    bindClicks();
    var picker = document.querySelector('.mtl-p .step.step-finish');
    if (picker) {
      var obs = new MutationObserver(function() {
        bindClicks();
        updateLabel();
      });
      obs.observe(picker, { attributes: true, subtree: true, attributeFilter: ['class', 'aria-pressed'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }
  setTimeout(init, 600);
  setTimeout(init, 1800);
})();
